import React from 'react';
import { TailSpin } from 'react-loader-spinner';

const Loader = ({ text, type }: { text: string; type?: 'normal' | 'full' }) => {
    const additionalClassName = type === 'full' ? 'immersion__loader__full' : '';
    return (
        <div className={`immersion__loader ${additionalClassName}`}>
            {type === 'full' && <div className='immersion__loader__content'>
                <h4>{text}</h4>
                <TailSpin
                    color="#3D62AE"
                    height={50}
                    width={50}
                    visible={true}
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperClass="immersion__loader__tail_spin"
                />
            </div>}

            {type !== 'full' &&
                <React.Fragment>
                    <h4>{text}</h4>
                    <TailSpin
                        color="#3D62AE"
                        height={50}
                        width={50}
                        visible={true}
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperClass="immersion__loader__tail_spin"
                    />
                </React.Fragment>
            }
        </div >
    )
}

export default Loader